import { render, staticRenderFns } from "./KnowledgeManagement.vue?vue&type=template&id=2899f359&scoped=true"
import script from "./KnowledgeManagement.vue?vue&type=script&lang=js"
export * from "./KnowledgeManagement.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeManagement.vue?vue&type=style&index=0&id=2899f359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899f359",
  null
  
)

export default component.exports